import React, { Component } from "react";
import { Icon } from "react-icons-kit";
import { iosArrowForward } from "react-icons-kit/ionicons/iosArrowForward";
import { polaroid } from "react-icons-kit/ikons/polaroid";
import { iosArrowDown } from "react-icons-kit/ionicons/iosArrowDown";
import dailyDueCompleted from "images/ReVAMP/dailyDueG.png";
import dailyDuePending from "images/ReVAMP/dailyDueBlack.png";
import LocoCompliant from "images/ReVAMP/compliant.png";
import LocoNonCompliant from "images/ReVAMP/nonCompliant.png";
import LocoOutOfUse from "images/ReVAMP/outOfUse.png";
import TooltipContainer from "../../../libraries/TooltipContainer";
import { languageService } from "../../../Language/language.service";
import permissionCheck from "../../../utils/permissionCheck";
import { versionInfo } from "../../MainPage/VersionInfo";

class Card extends Component {
  constructor(props) {
    super(props);
    // Initialize state
    this.state = {
      isAttributesCollapsed: true,
      isTestsCollapsed: false,
    };
  }

  // Toggle the collapse state for the Attributes section
  toggleAttributes = () => {
    this.setState((prevState) => ({
      isAttributesCollapsed: !prevState.isAttributesCollapsed,
    }));
  };
  toggleTests = () => {
    this.setState((prevState) => ({
      isTestsCollapsed: !prevState.isTestsCollapsed,
    }));
  };
  handleSelectClick = (e) => {
    //e.stopPropagation();
    // pass only the id
    if (this.props.onSelect) {
      this.props.onSelect(this.props.assetData._id);
    }
  };
  render() {
    const { showSelectButton } = this.props;
    const { order, data, assetStates } = this.props.data;
    const isSelected = this.props.isSelected;
    const Header = () => data["Asset Info"] && data["Asset Info"][0] && data["Asset Info"][0].value;
    const { isAttributesCollapsed } = this.state;
    const classN = isSelected ? "cv_card2Selected" : "cv_card2";
    return (
      <div className={this.props.renderAvailableTestsAsList ? classN : "cv_card"}>
        <span
          style={{
            fontSize: "larger",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "5px",
          }}
        >
          <span>{Header()}</span>

          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {/* Show "Select" button only if renderAvailableTestsAsList is true */}
            {this.props.renderAvailableTestsAsList && showSelectButton && (
              <button
                disabled={this.props.disableSelect}
                style={{
                  padding: "4px 8px",
                  fontSize: "12px",
                  backgroundColor: isSelected ? "#fff" : "#424d5aff",
                  color: isSelected ? "#424d5aff" : "#fff",
                  border: "2px solid #424d5aff",
                  borderRadius: "3px",
                  cursor: this.props.disableSelect ? "not-allowed" : "pointer",
                  opacity: this.props.disableSelect ? 0.5 : 1,
                }}
                onClick={this.handleSelectClick}
              >
                {isSelected ? "Selected" : "Select"}
              </button>
            )}
            {/* polaroid */}

            {this.props.showBlueCardIcon && permissionCheck("BLUECARD", "initialize") && (
              <TooltipContainer tooltipText={languageService("Initialize Blue Card")}>
                <Icon
                  className="cvViewIcon"
                  style={{ cursor: "pointer" }}
                  onClick={() => this.props.handleBlueCardInitialize(this.props.assetData)}
                  icon={polaroid}
                  size={20}
                />
              </TooltipContainer>
            )}

            {!this.props.renderAvailableTestsAsList && (
              <TooltipContainer tooltipText={languageService("View Asset Details")}>
                <Icon
                  className="cvViewIcon"
                  style={{ cursor: "pointer" }}
                  onClick={() => this.props.handleAssetView(this.props.assetData)}
                  icon={iosArrowForward}
                  size={20}
                />
              </TooltipContainer>
            )}
          </div>
        </span>

        {order.map((category, index) => (
          <div key={index} className="cv_card_item">
            <h5 style={{ display: "flex", alignItems: "center" }}>
              {category}
              {category === "Asset Info" && assetStates && (
                <span style={{ marginLeft: "10px", display: "flex", alignItems: "center", gap: "5px" }}>
                  <TooltipContainer tooltipText={languageService(assetStates.nonCompliant ? "Non Compliant" : "Compliant")}>
                    <span>
                      <img
                        style={{ width: "24px" }}
                        src={assetStates.nonCompliant ? LocoNonCompliant : LocoCompliant}
                        alt={"compliance status"}
                      />
                    </span>
                  </TooltipContainer>
                  {assetStates.outOfUse ? (
                    <TooltipContainer tooltipText={languageService("Out of use")}>
                      <span>
                        <img style={{ width: "24px" }} src={LocoOutOfUse} alt={"Out of use"} />
                      </span>
                    </TooltipContainer>
                  ) : (
                    !versionInfo.isDailyDisabled() && (
                      <TooltipContainer
                        tooltipText={languageService(assetStates.dailyDue ? "Daily Inspection Due" : "Daily Inspection Completed")}
                      >
                        <span>
                          <img
                            style={{ width: "24px" }}
                            src={assetStates.dailyDue ? dailyDuePending : dailyDueCompleted}
                            alt={"daily status"}
                          />
                        </span>
                      </TooltipContainer>
                    )
                  )}
                </span>
              )}

              {(category === "Attributes" || category === "Available Tests") && (
                <span
                  style={{ marginLeft: "10px", cursor: "pointer", display: "flex", alignItems: "center" }}
                  onClick={category === "Attributes" ? this.toggleAttributes : this.toggleTests}
                >
                  <Icon
                    icon={
                      category === "Attributes"
                        ? this.state.isAttributesCollapsed
                          ? iosArrowForward
                          : iosArrowDown
                        : this.state.isTestsCollapsed
                          ? iosArrowForward
                          : iosArrowDown
                    }
                    size={20}
                    style={{ marginRight: "5px" }}
                  />
                </span>
              )}
            </h5>
            {(category !== "Available Tests" || !this.state.isTestsCollapsed) &&
              category === "Available Tests" &&
              this.props.renderAvailableTestsAsList && (
                <div style={{ paddingLeft: "0px", margin: 0, width: "100%", display: "flex", flexDirection: "column" }}>
                  {data[category].map((item, i) => (
                    <div style={{ display: "flex", width: "100%", flexDirection: "row", justifyContent: "space-between" }}>
                      <strong style={{ flex: 1, fontSize: "12px" }}>{item.name}</strong>
                      <div>
                        {(item.statusLine1 || item.statusLine2) && (
                          <span style={{ color: item.statusColor || "#000", fontSize: "12px" }}>
                            {item.statusLine1}
                            {item.statusLine2 ? ` (${item.statusLine2})` : ""}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            <div className="cv_card_item_value">
              {(category !== "Attributes" || !isAttributesCollapsed) && category !== "Available Tests"
                ? data[category].map((item, i) => (
                    <div key={i}>
                      <strong>{item.name}:</strong>{" "}
                      <div style={{ textAlign: "right" }}>
                        {["Drilled", "Event Recorder (N/A)"].includes(item.name) ? (item.value ? "Yes" : "No") : item.value}
                      </div>
                    </div>
                  ))
                : null}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/LampAssets/CardView/Card.jsx